import type { PropsWithChildren } from 'react';

export const TileSkeleton = ({ children }: PropsWithChildren) => (
	<div className="flex flex-col gap-2 mb-4 pb-8 border-b border-(--border-subtlest)">
		{children}
	</div>
);
